'use client'

import Image from 'next/image'
import * as React from 'react'

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface ImageViewDialogProps {
  imageUrl: string | null
  onClose: () => void
}

export function ImageViewDialog({ imageUrl, onClose }: ImageViewDialogProps) {
  if (!imageUrl) return null

  return (
    <Dialog open={Boolean(imageUrl)} onOpenChange={onClose}>
      <DialogContent
        className={cn(
          'max-w-[90vw] md:max-w-[800px] border-none bg-transparent p-0 shadow-none'
        )}
      >
        <DialogTitle className="sr-only">Image Preview</DialogTitle>
        <div className="relative overflow-hidden rounded-2xl bg-[#1F2023] shadow-2xl">
          <Image
            src={imageUrl}
            alt="Full preview"
            width={800}
            height={600}
            className="max-h-[80vh] w-full object-contain"
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
